import { Component, inject, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { QuotationService } from '@retail-portal-santander-frontend/shared-data-access';
import { LoaderOverlayComponent } from '@retail-portal-santander-frontend/remote-shared-ui-loader-overlay';

@Component({
  imports: [RouterModule, LoaderOverlayComponent],
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly quotationService = inject(QuotationService);

  readonly loading: Signal<boolean> = this.quotationService.loading;
}
